import React from 'react';

import infoIcon from '../../../../../icons/info.svg';

import classes from './InfoField.css';

const InfoField = (props) => {

    return (
        <div className={classes.InfoField} onClick={props.clicked}>
            <img src={infoIcon} alt="not found"/>
        </div>    
    )

}


export default InfoField;



// WEBPACK FOOTER //
// ./src/components/UI/HowItWorks/TrdHowItWorks/InfoField/InfoField.js